// extracted by mini-css-extract-plugin
export default {"btn":"button_btn__QJtXk","disabled":"button_disabled__-Lom4","shadow":"button_shadow__WWLWO","buttonGroup":"button_buttonGroup__5HNeb"};